import React from 'react';

const STEPS = [
  {
    body: 'Five flash questions pulled straight from the day’s biggest tech stories.',
    title: 'Vote on today’s five',
  },
  {
    body: 'Answer, and the results reveal instantly. See how your take stacks up.',
    title: 'See how the industry voted',
  },
  {
    body: 'A fresh set of polls lands every night at midnight PT.',
    title: 'Come back tomorrow',
  },
];

const HowItWorks = () => (
  <section
    aria-labelledby="polls-how-it-works"
    className="bg-background-white py-48 sm:py-64 md:py-80 xl:py-96"
  >
    <div className="mx-auto w-full max-w-[1440px] px-20 sm:px-40 lg:px-64 xl:px-80">
      <p className="m-0 font-suisse-intl-mono text-[14px] uppercase leading-none tracking-widest text-primary-magenta">
        How it works
      </p>
      <h2
        className="m-0 mt-20 font-suisse-intl text-[30px] font-bold leading-[1.1] tracking-tight text-grayscale-charcoal sm:text-[40px] md:text-[44px] xl:text-[52px]"
        id="polls-how-it-works"
      >
        A couple of minutes. Every day.
      </h2>
      <ul className="m-0 mt-40 grid list-none grid-cols-1 gap-x-24 gap-y-28 p-0 min-[688px]:grid-cols-3 sm:mt-48 md:gap-x-32 xl:mt-56">
        {STEPS.map(({ body, title }) => (
          <li
            className="border-0 border-t-2 border-solid border-grayscale-charcoal pt-28"
            key={title}
          >
            <h3 className="m-0 font-suisse-intl text-[20px] font-bold leading-[1.25] text-grayscale-charcoal sm:text-[22px] md:text-[24px] xl:text-[26px]">
              {title}
            </h3>
            <p className="m-0 mt-16 text-pretty font-suisse-intl text-[16px] font-normal leading-[1.55] text-grayscale-charcoal md:text-[17px] xl:text-[18px]">
              {body}
            </p>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default HowItWorks;
